import React, { useContext, useEffect, useState } from 'react';

import { getSiteJsonSchema, ISmartSiteContext } from '../../api/smartApi';
// import { isMobile } from '../../util/device';
import { useScreenSize } from '../ScreenSize';

export const Context = React.createContext<ISmartSiteContext>({
  __smart: {
    siteMap: {},
    subSiteMap: {},
    mSiteMap: {},
    mSubSiteMap: {},
  },
});

export function useSmartSite(url: string) {
  const context = useContext(Context);
  const { __smart } = context;
  const [schema, setSchema] = useState<any>();
  const { size } = useScreenSize();

  useEffect(() => {
    const { subSiteMap, mSubSiteMap } = __smart;

    if (size?.width <= 0) {
      return;
    }

    let schemaUrl = subSiteMap[url];

    // if (isMobile()) {
    if (size?.width < 1024) {
      schemaUrl = mSubSiteMap[url];
    }

    if (schemaUrl) {
      getSiteJsonSchema(schemaUrl.webPageContentUrl).then((s) => {
        setSchema(s);
      });
    }
  }, [url, __smart, size?.width]);

  return {
    schema,
  };
}
